import { Form, redirect } from "react-router-dom";
import { useState } from "react";

import CompanyStepOne from "./CompanyStepOne";
import CompanyStepTwo from "./CompanyStepTwo";
import CompanyStepThree from "./CompanyStepThree";

import { API_BASE_URL } from "../../../config";
import { getAuthToken } from "../../../auth/auth";

export default function CompanyApproval() {
  const [handleNum, setHandleNum] = useState(0);
  const [allResults, setAllResults] = useState([]);

  const handleIncrementStep = () => {
    setHandleNum((prevState) => prevState + 1);
  };

  const handleDecrementStep = () => {
    setHandleNum((prevState) => prevState - 1);
  };

  const handleSkillResults = (value) => {
    setAllResults(value);
  };

  const steps = [
    {
      component: (
        <CompanyStepOne
          num={handleNum + 1}
          handleIncrement={handleIncrementStep}
        />
      ),
    },
    {
      component: (
        <CompanyStepTwo
          num={handleNum + 1}
          handleDecrement={handleDecrementStep}
          handleIncrement={handleIncrementStep}
          handleResults={handleSkillResults}
        />
      ),
    },
    {
      component: (
        <CompanyStepThree
          num={handleNum + 1}
          handleDecrement={handleDecrementStep}
        />
      ),
    },
  ];

  return (
    <>
      <div className="select-role-wrapper-div company-form-select-wrapper">
        <Form method="post" encType="multipart/form-data">
          <input
            type="hidden"
            value={JSON.stringify(allResults)}
            name="job_type_categories"
          />
          <div className="select-rol-current-step">
            {steps.map((step, index) => (
              <div
                key={index}
                style={{ display: handleNum === index ? "block" : "none" }}
              >
                {step.component}
              </div>
            ))}
          </div>
        </Form>
      </div>
    </>
  );
}

export async function companyApprovalAction({ request }) {
  const formData = await request.formData();
  const token = getAuthToken();
  const data = new FormData();

  data.append("current_role", formData.get("current_role"));

  const jobTypes = formData.get("job_types").split(",").map(Number);
  jobTypes.forEach((id) => {
    data.append("job_types[]", id);
  });

  const skillsFromHidden = JSON.parse(formData.get("job_type_categories"));

  skillsFromHidden.forEach((skillId) => {
    data.append("skills[]", skillId);
  });

  const response = await fetch(`${API_BASE_URL}/company/approval`, {
    method: "POST",
    body: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const result = await response.json();

  if (result.success === false) {
    return { error: result.message || "Failed for company approval." };
  }

  localStorage.setItem("approved", 1);
  return redirect("/company-under-review");
}
